import React, { Component } from 'react';

class LinkRow extends Component {
    render() {
        return (
            <div className="row linkRow">
            {
                this.props.links.map((link, i) => {
                    return(
                        <div key={i} className="col-sm">
                            <div>{link.title}</div>
                            {
                                link.addresses.map((address, j) => {
                                    return(
                                        <div key={i + "_" + j}>
                                            <a href={"http://" + address} target="__blank">{address}</a>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    )
                })
            }
            </div>
        );
    }
}

export default LinkRow;



// WEBPACK FOOTER //
// ./src/components/linkRow.jsx